import { useNode } from '@craftjs/core';
import React, { useCallback } from 'react';
import { Link } from '@descope/page-editor-components';
import { EditorLinkSettings } from './EditorLinkSettings';

const EditorLink = (props: React.ComponentProps<typeof Link>) => {
	const {
		connectors: { connect, drag }
	} = useNode();

	const refCb = useCallback(
		(ref: HTMLAnchorElement) => {
			connect(drag(ref));
		},
		[connect, drag]
	);

	// we are overriding the href with undefined so when clicking on the link in the editor it won't open a new tab
	// on the generated page the anchor element will get the href value
	return <Link ref={refCb} {...props} href={undefined} />;
};

EditorLink.craft = {
	name: 'Link',
	props: {
		children: 'Link',
		italic: false,
		typography: 'body1',
		align: 'center',
		fullWidth: false,
		target: '_blank',
		href: '',
		color: 'accent'
	},
	related: {
		settings: EditorLinkSettings
	}
};

export { EditorLink };
